export enum ProductKeys {
  SECURE_WORKLOAD = 'secure-workload',
  XDR = 'xdr',
}

export enum ProductPermissionStatus {
  ADDED = 'added',
  DELETED = 'deleted',
  UNCHANGED = 'unchanged',
}
